import { getDefaultSiteTemplate } from './site-templates/default-template';

export const TemplateService = ({ i18n }) => {
  const service = {};
  const defaultSiteTemplate = getDefaultSiteTemplate(i18n);

  service.getTemplates = () => [defaultSiteTemplate];

  service.defaultTemplate = () => defaultSiteTemplate;

  return service;
};
